/* eslint-disable */
import React from "react";
// @material-ui/core components
import {
  Input,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import ls from "local-storage";
// core components
import GridItem from "components/Grid/GridItem.js";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import GridContainer from "components/Grid/GridContainer.js";
import Search from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DateFnsUtils from "@date-io/date-fns";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
import { db, auth, storage } from "../Firebase/firebase.js";

const useStyles = makeStyles(styles);
export default function Sponsors() {
  const theme = useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setSponsorName("");
    setImage("");
    setCategory("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const classes = useStyles();

  ///////////////Hooks/////////////////
  //Edit
  const [editDocID, setEditDocID] = React.useState("");
  //Search
  const searchref = React.useRef("");
  const [searchflag, setsearchflag] = React.useState(true);
  //Data
  const [sponsorName, setSponsorName] = React.useState("");
  const [category, setCategory] = React.useState("");
  const [sponsorCategory, setSponsorCategory] = React.useState("");
  const [list, setList] = React.useState([]);

  const handleNameChange = (name) => {
    setSponsorName(name.target.value);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const handleSponsorCategoryChange = (e) => {
    setSponsorCategory(e.target.value);
  };

  //Handling Update Dialog
  const [openEditDialog, setEditDialog] = React.useState(false);

  const handleVEditClickOpen = () => {
    setEditDialog(true);
  };
  const handleEditArrowClose = () => {
    setEditDialog(false);
  };

  //Handling Delete
  const [opendeletebox, setopendeletebox] = React.useState(false);
  const [deleteDocID, setDeleteDocID] = React.useState(false);

  const openconfirmationbox = () => {
    setopendeletebox(true);
  };
  const closeconfirmationbox = () => {
    setopendeletebox(false);
  };
  const deleteDialog = (sponsor) => {
    setDeleteDocID(sponsor.docId);
    setopendeletebox(true);
  };

  /////////Image picker//////////
  const [image, setImage] = React.useState("");
  const imageRef = React.useRef(null);

  function useDisplayImage() {
    const [result, setResult] = React.useState("");

    function uploader(e) {
      const imageFile = e.target.files[0];

      const reader = new FileReader();
      reader.addEventListener("load", (e) => {
        setResult(e.target.result);
      });

      reader.readAsDataURL(imageFile);
    }

    return { result, uploader };
  }

  const { result, uploader } = useDisplayImage();

  const handleImageChange = (event) => {
    setImage(event.target.files[0]);
    uploader(event);
  };

  const [updateimgurl, setupdateimageurl] = React.useState("");
  const viewimageRef = React.useRef(null);
  const [viewimage, setviewImage] = React.useState("");
  function useDisplayImageforUpdate() {
    const [result2, setResult2] = React.useState();

    function uploader2(e) {
      const imageFile = e.target.files[0];

      const reader = new FileReader();
      reader.addEventListener("load", (e) => {
        setResult2(e.target.result);
        setupdateimageurl(e.target.result);
      });

      reader.readAsDataURL(imageFile);
    }

    return { result2, uploader2 };
  }

  const { result2, uploader2 } = useDisplayImageforUpdate();

  const handleViewImageChange = (event) => {
    setviewImage(event.target.files[0]);
    uploader2(event);
  };

  ///////CRUD////////
  //Add Sponsor
  const addSponsor = () => {
    const ref = storage.ref(`/sponsors/${image.name}`);
    const uploadTask = ref.put(image);
    uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("sponsors")
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            db.collection("sponsors")
              .add({
                name: sponsorName,
                category: category,
                image: url,
              })
              .then((doc) => {
                db.collection("sponsors").doc(doc.id).set(
                  {
                    docId: doc.id,
                  },
                  { merge: true }
                );
              })
              .catch((err) => {
                console.log(err);
              });
            getSponsors();
            setOpen(false);
          });
      }
    );
  };

  //Get sponsors
  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
    } else {
      getSponsors();
    }
  }, []);

  var getSponsors = () => {
    let newArray = [];
    db.collection("sponsors")
    .orderBy("category","desc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setList(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  //Update
  const UpdateSponsor = () => {
    if (typeof viewimage === "object") {
      const ref = storage.ref(`/sponsors/${viewimage.name}`);
      const uploadTask = ref.put(viewimage);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref("sponsors")
            .child(viewimage.name)
            .getDownloadURL()
            .then((url) => {
              db.collection("sponsors")
                .doc(editDocID)
                .set(
                  {
                    name: sponsorName,
                    category: category,
                    image: url,
                  },
                  { merge: true }
                )
                .then(() => {
                  setEditDialog(false);
                  setTimeout(() => {
                    getSponsors();
                  }, 1000);
                })
                .catch((err) => {
                  console.log(err);
                });
            });
        }
      );
    } else {
      db.collection("sponsors")
        .doc(editDocID)
        .set(
          {
            name: sponsorName,
            category: category,
            image: viewimage,
          },
          { merge: true }
        )
        .then(() => {
          setEditDialog(false);
          setTimeout(() => {
            getSponsors();
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  //Delete
  const DeleteSponsor = () => {
    db.collection("sponsors")
      .doc(deleteDocID)
      .delete()
      .then(() => {
        setopendeletebox(false);
        getSponsors();
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };

  ////////Other operations/////////
  //Search sponsor
  const searchSponsor = () => {
    if (searchflag === true) {
      let newArray = [];
      db.collection("sponsors")
        .where("name", "==", searchref.current.value)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            newArray.push(doc.data());
          });
          setList(newArray);
          setsearchflag(false);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    } else {
      searchref.current.value = "";
      getSponsors();
      setsearchflag(true);
    }
  };

  //Update Sponsor
  const updateSponsorDialog = (row) => {
    setEditDocID(row.docId);
    setviewImage(row.image);
    setupdateimageurl(row.image);
    setSponsorName(row.name);
    setCategory(row.category);
    setEditDialog(true);
  };

  return (
    <>
      <GridContainer justify="space-between">
        <GridItem>
          <br></br>
          <Button
            onClick={handleClickOpen}
            style={{ backgroundColor: "#171942", marginLeft: 10 }}
          >
            Add Sponsor
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}>Add Sponsor</h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 450, width: 600 }}>
              {mobileratio ? <br></br> : <br></br>}
              <div
                className="imageContainer"
                style={{
                  width: "38%",
                  height: "150px",
                  backgroundColor: "grey",
                  marginLeft: mobileratio ? 0 : "auto",
                  marginRight: "auto",
                  marginBottom: "auto",
                  marginTop: "auto",
                }}
              >
                <img
                  src={result}
                  ref={imageRef}
                  alt=""
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundSize: "cover",
                  }}
                ></img>
              </div>
              <br></br>
              <div>
                <input
                  onChange={handleImageChange}
                  accept="image/*"
                  id="icon-button-file"
                  type="file"
                  style={{ display: "none" }}
                />
                <label
                  style={{
                    marginLeft: mobileratio ? 0 : 200,
                    marginTop: -20,
                  }}
                  htmlFor="icon-button-file"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    startIcon={<PhotoCamera />}
                  >
                    Upload
                  </Button>
                </label>
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Name"
                  variant="outlined"
                  onChange={handleNameChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
              </div>
              {mobileratio ? null : <br></br>}
              <FormControl
                variant="filled"
                className={classes.formControl}
                style={{ width: mobileratio ? 267 : 540 }}
                required
              >
                <InputLabel id="category_label">Category</InputLabel>
                <Select
                  labelId="sponsor_category"
                  id="sponsorCategory"
                  value={category}
                  onChange={handleCategoryChange}
                  label="Category"
                >
                  <MenuItem value="Gold">Gold</MenuItem>
                  <MenuItem value="Platinum">Platinum</MenuItem>
                  <MenuItem value="Silver">Silver</MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 560,
                  backgroundColor: "#171942",
                }}
                onClick={addSponsor}
                autoFocus
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit Sponsor Dialog */}
          <Dialog
            open={openEditDialog}
            onClose={handleEditArrowClose}
            aria-labelledby="event-title"
            aria-describedby="event-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleEditArrowClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 450, width: 600 }}>
              {mobileratio ? <br></br> : <br></br>}
              <div
                className="imageContainer"
                style={{
                  width: "38%",
                  height: "150px",
                  backgroundColor: "grey",
                  marginLeft: mobileratio ? 0 : "auto",
                  marginRight: "auto",
                  marginBottom: "auto",
                  marginTop: "auto",
                }}
              >
                <img
                  src={updateimgurl}
                  ref={viewimageRef}
                  alt=""
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundSize: "cover",
                  }}
                ></img>
              </div>
              <br></br>
              <div>
                <input
                  onChange={handleViewImageChange}
                  accept="image/*"
                  id="icon-button-file"
                  type="file"
                  style={{ display: "none" }}
                />
                <label
                  style={{
                    marginLeft: mobileratio ? 0 : 200,
                    marginTop: -20,
                  }}
                  htmlFor="icon-button-file"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    startIcon={<PhotoCamera />}
                  >
                    Upload
                  </Button>
                </label>
                <br></br>
                <br></br>
                <TextField
                  required
                  label="Name"
                  variant="outlined"
                  defaultValue={sponsorName}
                  onChange={handleNameChange}
                  style={{ width: mobileratio ? 267 : 540 }}
                />
              </div>
              {mobileratio ? null : <br></br>}
              <FormControl 
                variant="outlined"
                className={classes.formControl}
                style={{ width: mobileratio ? 267 : 540 }}
                required
              >
                <InputLabel id="category_label">Category</InputLabel>
                <Select
                  labelId="sponsor_category"
                  id="sponsorCategory"
                  value={category}
                  onChange={handleCategoryChange}
                  label="Category"
                >
                  <MenuItem value="Gold">Gold</MenuItem>
                  <MenuItem value="Platinum">Platinum</MenuItem>
                  <MenuItem value="Silver">Silver</MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 560,
                  backgroundColor: "#171942",
                }}
                onClick={UpdateSponsor}
                autoFocus
              >
                Update
              </Button>
            </DialogActions>
          </Dialog>

          {/* confirmation box */}
          <Dialog
            open={opendeletebox}
            onClose={closeconfirmationbox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Are you sure you want to delete this sponsor?
            </DialogTitle>
            <DialogContent></DialogContent>
            <DialogActions>
              <Button onClick={DeleteSponsor} color="primary">
                Yes
              </Button>
              <Button onClick={closeconfirmationbox} color="primary">
                No
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
        {/* Search button */}
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "500px" : "80px" }}>
            <TextField
              placeholder="Search"
              variant="outlined"
              inputRef={searchref}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={searchSponsor}>
                      {searchflag ? <SearchIcon /> : <ClearIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </GridItem>
      </GridContainer>
      <br></br>
      <Grid container spacing={3}>
        {list.map((row) => (
          <MediaCard
            sponsor={row}
            deleteMethod={() => deleteDialog(row)}
            updateMethod={() => updateSponsorDialog(row)}
          />
        ))}
      </Grid>
    </>
  );
}

const useStyless = makeStyles({
  root: {
    width: 345,
    backgroundColor: "#DDDDDD",
    shadowColor: "#000000",
    shadowOpacity: 0.9,
    shadowRadius: 6,
    shadowOffset: {
      height: 6,
      width: 6,
    },
  },
  media: {
    height: 200,
    backgroundSize:"contain",
    margin:10
  },
});

function MediaCard({ sponsor, deleteMethod, updateMethod }) {
  const classes = useStyless();
  const [openPopup, setOpenPopup] = React.useState(false);

  return (
    <Box m={3} pt={5}>
      <Card className={classes.root} style={{backgroundColor:"#171942"}}>
        <CardActionArea onClick={updateMethod}>
          <CardMedia className={classes.media} image={sponsor.image} />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2" style={{color:"white",fontWeight:'bold'}}>
              {sponsor.name}
            </Typography>
            <h5 style={{ display: "inline-block", fontWeight:"lighter", fontSize: 18,color:"white" }}>
              {sponsor.category}
            </h5>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            style={{ backgroundColor: "white",color:"black", marginLeft: "60%" }}
            onClick={deleteMethod}
          >
            Delete
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
}
